import {Action, applyMiddleware, combineReducers, createStore as reduxCreateStore} from 'redux';
import {createBrowserHistory, History} from 'history';
import thunk, {ThunkDispatch} from 'redux-thunk';

import {UsersReducer} from '../users/reducers';
import {ProductsReducer} from '../products/reducers';
import infoReducer, {InfoState} from '../info/slice';
import {useDispatch, useSelector} from "react-redux";
import orderReducer, {OrderState} from "../orders/slice";
import categoryReducer, {CategoryState} from "../categories/slice";
import globalReducer, {GlobalState} from "../global/slice";

export type RootState = {
  users: ReturnType<typeof UsersReducer>;
  products: ReturnType<typeof ProductsReducer>;
  info: InfoState;
  orders: OrderState,
  categories: CategoryState,
  global: GlobalState
}
// history: パスの情報が入ったもの
const createStore = (history: History) => {
  // reduxのcreateStoreメソッドをreturn
  return reduxCreateStore(
    // combineReducersでstateを生成
    // 分割したReducersをまとめる
    combineReducers({ 
      users: UsersReducer,
      products: ProductsReducer,
      info: infoReducer,
      orders: orderReducer,
      categories: categoryReducer,
      global: globalReducer
    }),
    // ルーターをmiddlewareとして使用することを宣言
    applyMiddleware(
      thunk // redux-thunkを導入
    )
  )
}

const history = createBrowserHistory();
// createStore関数を実行して、Storeを作る
const store = createStore(history);
export function useAppSelector<Return>(selector: (state: RootState) => Return) {
    return useSelector(selector)
}

export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;
export const useAppThunkDispatch = () => useDispatch<ThunkAppDispatch>();

export default store
